import S3Image from "./S3Image";

function imagePathToS3(imagePath) {
    return S3Image(imagePath.replace("https://s3.us-west-2.amazonaws.com/citydata.media/citydata.ai/images/",""));
}

export default imagePathToS3;